import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import Seo from "@/components/feature/Seo";
import Breadcrumb from "@/components/feature/Breadcrumb";
import Reveal from "@/components/base/Reveal";
import SubmitForm from "./components/SubmitForm";
import { submitSteps, siteInfo } from "@/mocks/site";

const privacyPoints = [
  {
    icon: "ri-eye-off-line",
    title: "设备信息不做留存",
    desc: "投稿不记录 IP 归属地以外的设备标识，也不做跨站追踪。",
  },
  {
    icon: "ri-image-circle-ai-line",
    title: "截图统一重制",
    desc: "图片中的水印、头像、昵称会统一替换后再对外发布。",
  },
  {
    icon: "ri-forbid-2-line",
    title: "不对第三方披露",
    desc: "除依法配合的必要情形外，我们不会把投稿来源提供给任何第三方。",
  },
  {
    icon: "ri-arrow-go-back-line",
    title: "随时可以撤回",
    desc: "稿件未排期发布前，你可以通过原通道申请撤回并停止处理。",
  },
];

const acceptList = [
  "事件的时间、地点与大致经过",
  "涉及方的公开身份或所属机构",
  "聊天记录、合同、票据等可核对的材料",
  "现场照片、视频或录音线索",
];

const rejectList = [
  "未成年人隐私、私人住址与家庭成员信息",
  "没有事实依据、只有情绪表达的内容",
  "针对个人的商业诋毁与人身攻击",
  "涉及正在侦办案件的敏感细节",
];

export default function SubmitPage() {
  const submitJsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "ContactPage",
      name: "投稿入口 - 瓜友会网",
      url: "https://tn8v0ac.cn/submit",
      description:
        "瓜友会网匿名爆料与投稿入口，全天候接收线索征集，全程保护投稿者隐私。",
      inLanguage: "zh-CN",
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "首页", item: "https://tn8v0ac.cn" },
        { "@type": "ListItem", position: 2, name: "投稿入口", item: "https://tn8v0ac.cn/submit" },
      ],
    },
  ];

  return (
    <>
      <Seo
        title="投稿入口 - 瓜友会网 | 匿名爆料通道 24 小时开放"
        description="瓜友会网投稿入口全天开放，支持匿名提交线索、截图、录音与文件。投稿者身份不公开，截图统一重制，稿件未发布前可随时撤回，让手里有料的人安心开口。"
        keywords="瓜友会网投稿入口,匿名爆料,线索征集,独家消息投稿,隐私保护"
        path="/submit"
        jsonLd={submitJsonLd}
      />
      <SiteHeader />
      <main>
        <section className="border-b border-background-200 bg-background-100">
          <div className="mx-auto w-full px-4 py-9 md:px-6 md:py-12 lg:px-10">
            <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "投稿入口" }]} />
            <h1 className="mt-5 max-w-4xl font-heading text-3xl font-bold tracking-tight text-foreground-950 md:text-[40px] md:leading-[1.3]">
              匿名投稿入口：有料你就来
            </h1>
            <p className="mt-4 max-w-3xl text-sm leading-8 text-foreground-600 md:text-[15px]">
              不需要实名，不需要解释你为什么知道。写下你掌握的信息，剩下的核对、去标识化与发布，交给编辑部。
              投稿通道 24 小时开放，编辑核实时间为 09:00 - 23:00。
            </p>
          </div>
        </section>

        <section className="mx-auto w-full px-4 py-12 md:px-6 lg:px-10">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
            <div className="lg:col-span-5">
              <Reveal>
                <div className="rounded-lg border border-background-200 bg-background-100 p-6">
                  <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                    <i className="ri-shield-user-line text-xl text-secondary-700" aria-hidden="true" />
                    我们如何保护你
                  </h2>
                  <ul className="mt-5 space-y-5">
                    {privacyPoints.map((point) => (
                      <li key={point.title} className="flex items-start gap-3">
                        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-base text-secondary-800">
                          <i className={point.icon} aria-hidden="true" />
                        </span>
                        <div>
                          <h3 className="text-sm font-medium text-foreground-900">{point.title}</h3>
                          <p className="mt-1 text-sm leading-7 text-foreground-600">{point.desc}</p>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </Reveal>

              <Reveal delay={100}>
                <div className="mt-6 rounded-lg border border-background-200 bg-background-50 p-6">
                  <h2 className="font-heading text-lg font-bold text-foreground-950">什么样的线索更容易被采纳</h2>
                  <div className="mt-4 grid grid-cols-1 gap-4">
                    <div>
                      <p className="mb-2 flex items-center gap-1.5 text-sm font-medium text-secondary-800">
                        <i className="ri-checkbox-circle-line text-base" aria-hidden="true" />
                        欢迎提交
                      </p>
                      <ul className="space-y-1.5 text-sm leading-7 text-foreground-600">
                        {acceptList.map((item) => (
                          <li key={item} className="flex items-start gap-2">
                            <span className="mt-2.5 h-1.5 w-1.5 shrink-0 rounded-full bg-secondary-400" />
                            {item}
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="border-t border-background-200 pt-4">
                      <p className="mb-2 flex items-center gap-1.5 text-sm font-medium text-accent-700">
                        <i className="ri-close-circle-line text-base" aria-hidden="true" />
                        不予发布
                      </p>
                      <ul className="space-y-1.5 text-sm leading-7 text-foreground-600">
                        {rejectList.map((item) => (
                          <li key={item} className="flex items-start gap-2">
                            <span className="mt-2.5 h-1.5 w-1.5 shrink-0 rounded-full bg-accent-400" />
                            {item}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </Reveal>

              <Reveal delay={160}>
                <div className="mt-6 rounded-lg bg-foreground-950 p-6 text-background-100">
                  <h2 className="font-heading text-lg font-bold text-background-50">也可以直接来信</h2>
                  <p className="mt-2 text-sm leading-7 text-background-300">
                    如果不方便填写表单，可以把整理好的材料直接发到投稿邮箱，注明希望的匿名方式。
                  </p>
                  <p className="mt-4 flex items-center gap-2 text-sm text-primary-300">
                    <i className="ri-mail-send-line text-base" aria-hidden="true" />
                    {siteInfo.email}
                  </p>
                </div>
              </Reveal>
            </div>

            <div className="lg:col-span-7">
              <Reveal>
                <SubmitForm />
              </Reveal>

              <Reveal delay={100}>
                <div className="mt-8">
                  <h2 className="font-heading text-lg font-bold text-foreground-950">投稿之后的流程</h2>
                  <ol className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2">
                    {submitSteps.map((step) => (
                      <li
                        key={step.seq}
                        className="flex items-start gap-3 rounded-lg border border-background-200 bg-background-50 p-4"
                      >
                        <span className="font-heading text-xl font-bold text-primary-400">{step.seq}</span>
                        <div>
                          <h3 className="text-sm font-medium text-foreground-900">{step.title}</h3>
                          <p className="mt-1 text-xs leading-6 text-foreground-600">{step.desc}</p>
                        </div>
                      </li>
                    ))}
                  </ol>
                </div>
              </Reveal>
            </div>
          </div>
        </section>
      </main>
      <SiteFooter />
      <BackToTop />
    </>
  );
}